var _rect, _path, _line, _line2, _line3, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIaParameterization(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.25,
    y: 17.25,
    width: 52.5,
    height: 76.5,
    rx: 9.75,
    fill: "white",
    stroke: "#534E50",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 40V45C26 45.6914 26.5586 46.25 27.25 46.25H28.5V38.75H27.25C26.5586 38.75 26 39.3086 26 40ZM44.125 33.75H39.75V31.25C39.75 30.5586 39.1914 30 38.5 30C37.8086 30 37.25 30.5586 37.25 31.25V33.75H32.875C31.1484 33.75 29.75 35.1484 29.75 36.875V47.5C29.75 48.8789 30.8711 50 32.25 50H44.75C46.1289 50 47.25 48.8789 47.25 47.5V36.875C47.25 35.1484 45.8516 33.75 44.125 33.75ZM36 46.25H33.5V45H36V46.25ZM34.75 41.5625C33.8867 41.5625 33.1875 40.8633 33.1875 40C33.1875 39.1367 33.8867 38.4375 34.75 38.4375C35.6133 38.4375 36.3125 39.1367 36.3125 40C36.3125 40.8633 35.6133 41.5625 34.75 41.5625ZM39.75 46.25H37.25V45H39.75V46.25ZM43.5 46.25H41V45H43.5V46.25ZM42.25 41.5625C41.3867 41.5625 40.6875 40.8633 40.6875 40C40.6875 39.1367 41.3867 38.4375 42.25 38.4375C43.1133 38.4375 43.8125 39.1367 43.8125 40C43.8125 40.8633 43.1133 41.5625 42.25 41.5625ZM49.75 38.75H48.5V46.25H49.75C50.4414 46.25 51 45.6914 51 45V40C51 39.3086 50.4414 38.75 49.75 38.75Z",
    fill: "#198754"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 58.5,
    x2: 48,
    y2: 58.5,
    stroke: "#198754"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 67.5,
    x2: 41,
    y2: 67.5,
    stroke: "black"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 76.5,
    x2: 48,
    y2: 76.5,
    stroke: "#198754"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.646 40C86.886 40.0094 91.6437 42.0743 95.1562 45.4311L97.9803 42.6071C99.1759 41.4116 101.22 42.2583 101.22 43.949V54.5494C101.22 55.5975 100.37 56.4471 99.3222 56.4471H88.7219C87.0311 56.4471 86.1844 54.403 87.3799 53.2074L90.6812 49.9062C88.2407 47.621 85.0828 46.3552 81.7278 46.3263C74.4217 46.2632 68.2631 52.1759 68.3263 59.7245C68.3862 66.8854 74.1917 72.8942 81.61 72.8942C84.862 72.8942 87.9356 71.7336 90.3577 69.6083C90.7327 69.2792 91.2991 69.2992 91.652 69.652L94.7881 72.7882C95.1734 73.1734 95.1543 73.8015 94.75 74.1666C91.2728 77.3075 86.6648 79.22 81.61 79.22C70.7797 79.22 62.0001 70.4403 62 59.6102C61.9999 48.7923 70.8281 39.9807 81.646 40Z",
    fill: "#198754"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.268 54.66V63H76.9V54.66H78.268ZM85.0921 61.296H81.6001L81.0001 63H79.5721L82.5601 54.648H84.1441L87.1321 63H85.6921L85.0921 61.296ZM84.7081 60.18L83.3521 56.304L81.9841 60.18H84.7081Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIaParameterization);
export default __webpack_public_path__ + "static/media/ia_parameterization.179e9ac5cf6adc19c6144eff7379a574.svg";
export { ForwardRef as ReactComponent };